export const FileUploadStatus = {
  Pending: 0,
  InProgress: 1,
  Canceled: 2,
  Failed: 3,
  Done: 4,
}
